import { init } from '@sentry/browser'
/*
if (process.env.NODE_ENV === 'production') {
  init({ dsn: 'https://7ee1984b392349f78fa812be373c0935@sentry.quamm.it/13' })
}
*/
init({ dsn: 'https://7ee1984b392349f78fa812be373c0935@sentry.quamm.it/13' })